import { Filter } from '../types/filter';

/**
 * A filter tree is "simple" when the list tab can fully represent it:
 * null, a single field filter, or one AND level of field filters.
 * Anything deeper (nested groups, OR at top level) requires the custom tab.
 */
export function isSimpleFilter<T extends object>(filter: Filter<T> | null): boolean {
  if (!filter) return true;
  if (filter.type !== 'conditions') return true;
  if (filter.operator !== 'AND') return false;
  return filter.filters.every((o) => o.type !== 'conditions');
}
